import React from 'react';
import { CompanyContact, CurrentUser } from '../../shared/models';
import { Card, CardActions, CardContent, Grid } from '@mui/material';
import { CerebroLabel, CerebroText, CerebroTextButton } from '../../shared/components';

interface AvailableBorrowerListProps {
	currentUser: CurrentUser;
	hasFullAccess: boolean;
	borrowers: CompanyContact[];
	onAdd: (record: CompanyContact) => void;
}

export const AvailableBorrowerList: React.FC<AvailableBorrowerListProps> = ({
	currentUser,
	hasFullAccess,
	borrowers,
	onAdd,
}) => {
	return (
		<Grid container spacing={2} alignItems="stretch">
			<Grid item xs={12}>
				{borrowers.map(contact => (
					<Card
						key={contact.guid}
						elevation={3}
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: 'column',
							height: '200px',
							marginBottom: 2,
						}}
					>
						<CardContent sx={{ paddingBottom: '0 !important' }}>
							<Grid container sx={{ marginBottom: 2 }}>
								<Grid item xs={8}>
									<CerebroText variant="large" component="span" sx={{ fontWeight: 'bold' }}>
										{contact.firstName} {contact.lastName}
									</CerebroText>
								</Grid>
								<Grid item xs={4} sx={{ textAlign: 'right' }}>
									<CerebroLabel sx={{ fontWeight: 'bold' }}>No Access</CerebroLabel>
								</Grid>
							</Grid>
							<CerebroText gutterBottom sx={{ marginTop: 3 }}>
								{contact.emailAddress}
							</CerebroText>
						</CardContent>
						{hasFullAccess && currentUser.personId != contact.personId && (
							<CardActions
								sx={theme => ({
									alignItems: 'flex-end',
									backgroundColor: theme.palette.gray.background,
									borderTop: `1px solid ${theme.palette.divider}`,
									justifyContent: 'space-between',
								})}
							>
								<CerebroTextButton size="small" onClick={() => onAdd(contact)}>
									Add Access
								</CerebroTextButton>
							</CardActions>
						)}
					</Card>
				))}
			</Grid>
		</Grid>
	);
};
